import React from "react";

function HeaderSocials(props) {
  return (
    <div className="home__socials">
      <a
        href="https://www.instagram.com/anoohya_nalla/"
        className="home__social-link"
      >
        <i className="fa-brands fa-instagram"></i>
      </a>

      <a href="https://twitter.com/AnoohyaNalla" className="home__social-link">
        <i className="fa-brands fa-twitter"></i>
      </a>

      <a href="https://github.com/anoohya-nalla" className="home__social-link">
        <i className="fa-brands fa-github"></i>
      </a>

      <a
        href="https://www.linkedin.com/in/anoohya-nalla/"
        className="home__social-link"
      >
        <i className="fa-brands fa-linkedin"></i>
      </a>
    </div>
  );
}

export default HeaderSocials;
